import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import "./styles/styles.scss";
import { Provider } from "react-redux";
import { store } from "./slices/store";
import MsalHandle from "./app/MsalHandle";
import "./styles/App.css";

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <Provider store={store}>
        <MsalHandle />
      </Provider>
    </BrowserRouter>
  );
}
